import React, { forwardRef, useState } from "react";
import DatePicker from "react-datepicker";
import InputMask from "react-input-mask";
import { parse, format, isValid } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./FormDatePicker.module.css";

export const FormDatePicker = forwardRef(
  (
    {
      dateString,
      setDate,
      label,
      dateFormat = "MM/dd/yyyy",
      minDateString,
      maxDateString,
      placeholder = "mm/dd/yyyy",
      disabled = false,
    },
    ref
  ) => {
    const [isOpen, setIsOpen] = useState(false);

    const parseStringToDate = (str) => {
      if (!str) return null;
      
      if (str.includes("Z")) {
        return new Date(str);
      }
      
      const parsed = parse(str, dateFormat, new Date());
      return isValid(parsed) ? parsed : null;
    };

    const selectedDate = parseStringToDate(dateString);
    const minDate = minDateString ? parseStringToDate(minDateString) : undefined;
    const maxDate = maxDateString ? parseStringToDate(maxDateString) : undefined;

    const handleChange = (date) => {
      if (date && isValid(date)) {
        const formattedDate = format(date, dateFormat);
        setDate(formattedDate);
      } else if (date === null) {
        setDate("");
      }
    };

    const handleTodayClick = () => {
      const today = new Date();
      handleChange(today);
      setIsOpen(false);
    };

    const handleClearClick = () => {
      handleChange(null);
      setIsOpen(false);
    };

    return (
      <div className={styles.container}>
        {label && <label className={styles.label}>{label}</label>}
        <DatePicker
          ref={ref}
          selected={selectedDate}
          onChange={handleChange}
          dateFormat={dateFormat}
          placeholderText={placeholder}
          minDate={minDate}
          maxDate={maxDate}
          readOnly={disabled}
          disabled={disabled}
          calendarStartDay={0}
          popperPlacement="bottom-start"
          showPopperArrow={true}
          open={isOpen}
          onClickOutside={() => setIsOpen(false)}
          onSelect={() => setIsOpen(false)}
          onInputClick={() => !disabled && setIsOpen(true)}
          customInput={
            <InputMask 
              mask="99/99/9999" 
              className={styles.datePicker}
              disabled={disabled}
              readOnly={disabled}
            >
              {(inputProps) => <input {...inputProps} />}
            </InputMask>
          }
          popperModifiers={[
            {
              name: "offset",
              options: {
                offset: [0, 4],
              },
            },
            {
              name: "preventOverflow",
              options: {
                rootBoundary: "viewport",
                tether: false,
                altAxis: true,
              },
            },
          ]}
          wrapperClassName={styles.datePickerWrapper}
          calendarClassName={styles.calendar}
        >
          <div className={styles.customButtons}>
            <button
              type="button"
              className={styles.clearButton}
              onClick={handleClearClick}
            >
              Clear
            </button>
            <button
              type="button"
              className={styles.todayButton}
              onClick={handleTodayClick}
            >
              Today
            </button>
          </div>
        </DatePicker>
      </div>
    );
  }
);

export default FormDatePicker;